<ion-content>

  <div class="error-page ion-padding ion-text-center">

    <!-- GEN060 custom error -->
    <ng-container *ngIf="isGen060; else genericError">
      <div class="gen060-card">

        <div class="gen060-illustration">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 160" fill="none">
            <!-- small bg cloud -->
            <ellipse cx="155" cy="52" rx="22" ry="14" fill="#dde8f8"/>
            <ellipse cx="168" cy="46" rx="14" ry="10" fill="#dde8f8"/>

            <!-- main cloud -->
            <ellipse cx="95" cy="95" rx="58" ry="36" fill="#c7d9f7"/>
            <ellipse cx="80" cy="72" rx="30" ry="26" fill="#c7d9f7"/>
            <ellipse cx="112" cy="68" rx="26" ry="22" fill="#c7d9f7"/>
            <ellipse cx="95" cy="95" rx="58" ry="36" fill="#d6e4fc"/>
            <ellipse cx="80" cy="72" rx="30" ry="26" fill="#d6e4fc"/>
            <ellipse cx="112" cy="68" rx="26" ry="22" fill="#d6e4fc"/>

            <!-- sad face -->
            <circle cx="83" cy="85" r="4" fill="#7a9ecf"/>
            <circle cx="107" cy="85" r="4" fill="#7a9ecf"/>
            <path d="M84 101 Q95 94 106 101" stroke="#7a9ecf" stroke-width="3" stroke-linecap="round" fill="none"/>

            <!-- warning triangle -->
            <polygon points="128,118 148,85 168,118" fill="#f5c518" stroke="#e6b800" stroke-width="1.5" stroke-linejoin="round"/>
            <rect x="146.5" y="95" width="3" height="12" rx="1.5" fill="#1a1a1a"/>
            <circle cx="148" cy="112" r="2" fill="#1a1a1a"/>

            <!-- sparkles -->
            <text x="170" y="75" font-size="14" fill="#f5c518">+</text>
            <text x="57" y="58" font-size="11" fill="#f5c518">+</text>
            <text x="178" y="120" font-size="10" fill="#f5c518">+</text>
          </svg>
        </div>

        <h2 class="gen060-title">We couldn't load the data right now</h2>
        <p class="gen060-msg">{{ gen060Message }}</p>

        <div class="gen060-actions">
          <button class="btn-try-again" (click)="tryAgain()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
            </svg>
            Try Again
          </button>
        </div>

      </div>
    </ng-container>

    <!-- Generic error -->
    <ng-template #genericError>
      <div class="message">
        <h1>{{code}}</h1>
        <h2>Oops, The page you are looking for can't be found!</h2>
      </div>
    </ng-template>

  </div>

</ion-content>